import { Skeleton } from '@sib/ui';

const SKELETON_LENGTH = 6;

export const TaskFormSkeleton = () => (
  <div className="flex w-full flex-col gap-4">
    <div className="flex w-full flex-col gap-5">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-10 w-full" />
      </div>
      <div className="flex flex-col gap-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-32 w-full" />
      </div>
    </div>
    <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-2">
      {Array.from({ length: SKELETON_LENGTH }).map((_, index) => (
        <div
          key={`ticket-form-skeleton-${index}`}
          className="flex flex-col gap-2"
        >
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-10 w-full" />
        </div>
      ))}
    </div>
    <div className="flex flex-col gap-2">
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-32 w-full rounded-lg" />
    </div>
    <div className="flex justify-end gap-2">
      <Skeleton className="h-10 w-24 rounded-md" />
      <Skeleton className="h-10 w-32 rounded-md" />
    </div>
  </div>
);
